import React from 'react'
import EditViewUpgradeMemberForm from '../../features/ViewIndividualMemberForm/EditViewUpgradeMemberForm'

const EditViewUpgradeMember = () => {
  return (<EditViewUpgradeMemberForm/>)
}

export default EditViewUpgradeMember